import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";

interface GiftBoxAnimationProps {
    onFinish: () => void;
    text: string;
}

const GiftBoxAnimation: React.FC<GiftBoxAnimationProps> = ({ onFinish, text }) => {
    const [showWelcomeText, setShowWelcomeText] = useState(false);
    const [animationData, setAnimationData] = useState<any>(null);

    useEffect(() => {
        fetch("/assets/admin/gift-box-loading-animation.json")
            .then((res) => res.json())
            .then(setAnimationData)
            .catch((err) => console.error("Failed to load Lottie JSON", err));
    }, []);

    useEffect(() => {
        // Lock body scroll when animation is shown
        document.body.style.overflow = 'hidden';

        const showTextTimer = setTimeout(() => {
            setShowWelcomeText(true);
        }, 9200);

        const completeTimer = setTimeout(() => {
            setShowWelcomeText(false);
            onFinish();
        }, 14000);

        return () => {
            // Restore body scroll when anim ation is removed
            document.body.style.overflow = 'unset';
            clearTimeout(showTextTimer);
            clearTimeout(completeTimer);
        };
    }, [onFinish]);

    if (!animationData) return null;

    return (
        <motion.div
            className="fixed top-0 left-0 w-full h-full bg-white flex items-center justify-center overflow-hidden"
            style={{
                zIndex: 9999,
                position: 'fixed',
                inset: 0
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className="flex items-center justify-center w-full h-full">
                <Lottie
                    animationData={animationData}
                    loop={false}
                    className="max-w-full max-h-full"
                    style={{ width: '900px', height: '900px' }}
                />
            </div>
            {showWelcomeText && (
                <motion.div
                    className="absolute inset-0 flex items-center justify-center"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    transition={{ duration: 0.5 }}
                    style={{ zIndex: 10000 }}
                >
                    <div className="bg-white bg-opacity-95 p-8 rounded-lg shadow-2xl border-4 border-green-600">
                        <h1 className="text-4xl font-bold text-center text-green-700">
                            {text}
                        </h1>
                    </div>
                </motion.div>
            )}
        </motion.div>
    );
};

export default GiftBoxAnimation;
